import NProgress from 'nprogress';

const NProgressApp = NProgress.configure({
  parent: '#nprogress-container',
  showSpinner: false
});

export { NProgressApp as default };
